var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _ellipse, _rect3, _path6, _path7, _rect4, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGateReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 70,
    viewBox: "0 0 154 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.9581,
    y: 15.75,
    width: 115.292,
    height: 16.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.094 31.5L57.3624 16.5H67.698L59.9463 31.5H49.094Z",
    fill: "#E93F22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5168 31.5L85.7852 16.5H96.1208L88.3691 31.5H77.5168Z",
    fill: "#E93F22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.423 31.5L113.691 16.5H124.027L116.275 31.5H105.423Z",
    fill: "#E93F22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.329 31.5L141.597 16.5H151.933L144.181 31.5H133.329Z",
    fill: "#E93F22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3758 131.17H9.30202L8.26846 18.6705C8.26846 -6.32951 42.8926 -3.40551 42.3758 18.6705V131.17Z",
    fill: "url(#paint0_linear_3_17)",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 52.7114,
    height: 11,
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8389,
    cy: 18,
    rx: 6.20134,
    ry: 6,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5839,
    y: 26,
    width: 40.3087,
    height: 65,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5839 91V26H83.2013V69.3333C83.2013 87.0606 96.1208 88.5379 100.772 88.5379H119.893V91H79.5839Z",
    fill: "#D9D9D9",
    fillOpacity: 0.42
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8188 31H97.6711M86.8188 35.5H102.322M86.8188 39H95.0872M86.8188 43.5H97.6711M86.8188 48H103.872M86.8188 52.5H96.6376M86.8188 57H101.289M93.5369 72.5H110.074M96.6376 76.5H105.423M111.624 31H115.758M111.624 35.5H115.758M111.624 39H115.758M111.624 43.5H115.758M111.624 48H115.758M111.624 52.5H115.758M111.624 57H115.758",
    stroke: "#9C9C9C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5839,
    y: 26,
    width: 40.3087,
    height: 65,
    fill: "#EDEBED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5839 91V26H83.2013V69.3333C83.2013 87.0606 96.1208 88.5379 100.772 88.5379H119.893V91H79.5839Z",
    fill: "#D9D9D9",
    fillOpacity: 0.42
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8188 31H97.6711M86.8188 35.5H102.322M86.8188 39H95.0872M86.8188 43.5H97.6711M86.8188 48H103.872M86.8188 52.5H96.6376M86.8188 57H101.289M93.5369 72.5H110.074M96.6376 76.5H105.423M111.624 31H115.758M111.624 35.5H115.758M111.624 39H115.758M111.624 43.5H115.758M111.624 48H115.758M111.624 52.5H115.758M111.624 57H115.758",
    stroke: "#9C9C9C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8523 23L83.7181 26H91.9866L87.8523 23Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8523 23L83.7181 26H91.9866L87.8523 23Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8523 23L83.7181 26H91.9866L87.8523 23Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8523 23L83.7181 26H91.9866L87.8523 23Z",
    fill: "#EDEBED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8523 94L83.7181 91H91.9866L87.8523 94Z",
    fill: "#E5E3E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.758 94L111.624 91H119.893L115.758 94Z",
    fill: "#EFEFEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.758 94L111.624 91H119.893L115.758 94Z",
    fill: "#E5E3E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.289 94L97.1544 91H105.423L101.289 94Z",
    fill: "#EFEFEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.289 94L97.1544 91H105.423L101.289 94Z",
    fill: "#E5E3E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.758 23L111.624 26H119.893L115.758 23Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.758 23L111.624 26H119.893L115.758 23Z",
    fill: "#EDEBED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.322 23L98.1879 26H106.456L102.322 23Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.322 23L98.1879 26H106.456L102.322 23Z",
    fill: "#EDEBED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_17",
    x1: 25.325,
    y1: 1,
    x2: 25.325,
    y2: 131.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1AAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605C57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGateReceipt);
export default __webpack_public_path__ + "static/media/icon_Gate Receipt.a60b2cdf1f5c8519649f503435a33b12.svg";
export { ForwardRef as ReactComponent };